import React from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { ACTIVITY_TYPE } from "../../../common/Constants";

export const getTableConfigDGI = ({ userAccess, onShowDetail }) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <React.Fragment>{rowNumber}</React.Fragment>;
      },
      sort: false,
    },
  },
  {
    name: "serviceDate",
    label: "Tanggal Service",
    options: {
      sort: false,
    },
  },
  {
    name: "dealerId",
    label: "Dealer ID",
    options: {
      sort: false,
    },
  },
  {
    name: "plateNumber",
    label: "Nomor Polisi",
    options: {
      sort: false,
    },
  },
  {
    name: "ownerName",
    label: "Nama Pemilik",
    options: {
      sort: false,
    },
  },
  {
    name: "carrierName",
    label: "Nama Pembawa",
    options: {
      sort: false,
    },
  },
  {
    name: "address",
    label: "Alamat",
    options: {
      sort: false,
    },
  },
  {
    name: "kabKotId",
    label: "Kode Kota",
    options: {
      sort: false,
    },
  },
  {
    name: "kecamatanId",
    label: "Kode Kecamatan",
    options: {
      sort: false,
    },
  },
  {
    name: "kelurahanId",
    label: "Kode Kelurahan",
    options: {
      sort: false,
    },
  },
  {
    name: "variantCode",
    label: "Kode Varian",
    options: {
      sort: false,
    },
  },
  {
    name: "",
    label: "Aksi",
    options: {
      sort: false,
      customBodyRender: (_, { rowIndex }) => {
        const color = !userAccess?.createAccess ? "gray" : "red";
        return (
          <FlexView hAlignContent="center" style={{ gap: "15px" }}>
            <SimpleButton
              type="button"
              category="action_button"
              styles={{ width: "unset" }}
              icon={<i className="fa fa-lg fa-eye color-red" />}
              onClick={() => onShowDetail(rowIndex, ACTIVITY_TYPE.VIEW)}
            />
            <SimpleButton
              category="action_button"
              type="button"
              disabled={!userAccess?.createAccess}
              styles={{ width: "unset" }}
              icon={
                <i className={`fa fa-lg fa-file-signature color-${color}`} />
              }
              onClick={() => {
                if (!userAccess?.createAccess) {
                  return;
                }
                onShowDetail(rowIndex, ACTIVITY_TYPE.CREATE);
              }}
            />
          </FlexView>
        );
      },
    },
  },
];
